import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentServiceList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentService', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'EquipmentService'}
            api='secondary'
            showTitle={true}
            title={'Equipment Services'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentServiceCrud', 'Create', t('Add')+' '+t('Equipment')+' '+ t('Service'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentServiceCrud', 'Edit', t('Edit')+' '+t('Equipment')+' '+ t('Service'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentServiceCrud', 'Copy', t('Copy')+' '+t('Equipment')+' '+ t('Service'), row)]
            ])}
        />
    )
}